import { useEffect, useState } from "react";
import { getTickets, getTitles } from "../../../Actions/HelpAction";
import { useSelector } from "react-redux";
import moment from "moment-jalaali";
import { Skeleton, Tag } from "antd";
import { Link } from "react-router-dom";
import FilterTickets from "./FilterTickets";
import Page from "../../Common/Page";
import queryString from 'query-string';
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";


const Ticketing = props => {

    const token = localStorage.getItem("userToken");

    const queryStringReserveId = queryString.parse(props.location.search)?.reserveId;

    const Dictionary = useSelector(state => state.VisualData.Dictionary);
    const LAN = useSelector(state => state.VisualData.LAN);

    const [tickets, setTickets] = useState();
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState([0, 9]);

    const initialFilterState = {
        Statuses: undefined,
        CreationTimeFrom: undefined,
        CreationTimeTo: undefined,
        ReserveId: queryStringReserveId,
        notRead: undefined
    };

    const getColor = (status) => {
        switch (status) {
            case 'Open':
                return '#2196f3';
            case 'InProgress':
                return '#ffba5b';
            case 'Answered':
                return '#93c053';
            case 'Closed':
                return '#555';
            default:
                return 'gray';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'Open':
                return Dictionary.Open;
            case 'InProgress':
                return Dictionary.InProgress;
            case 'Answered':
                return Dictionary.Answered;
            case 'Closed':
                return Dictionary.Closed;
            default:
                return status;
        }
    }


    const [filters, setFilters] = useState(initialFilterState);
    const [types, setTypes] = useState();

    useEffect(() => {

        const fetchData = async (params) => {
            setLoading(true);

            const response = await getTickets(params);

            setTickets(response?.data?.result?.items);
            setTotalCount(response?.data?.result?.totalCount);

            setLoading(false);
        }

        if (token) {
            const parameters = {
                token: token,
                MaxResultCount: 10,
                SkipCount: page[0],
                Statuses: filters.Statuses,
                CreationTimeFrom: filters.CreationTimeFrom,
                CreationTimeTo: filters.CreationTimeTo,
                ReserveId: filters.ReserveId,
                notRead: filters.notRead
            }
            fetchData(parameters);
        }

    }, [token, filters.CreationTimeFrom, filters.CreationTimeTo, filters.ReserveId, filters.Statuses, filters.notRead, page[0]]);

    const language = LAN === "IR" ? "fa-IR" : "en-US";

    useEffect(() => {
        const fetchTitles = async (t, lang) => {
            const response = await getTitles(t, lang);
            if (response.data?.result?.items) {
                setTypes(response.data.result.items);
            }
        }

        if (token && language) {
            fetchTitles(token, language);
        }

    }, [token, language]);

    const typeTitle = id => {
        return (types?.find(item => item.id === id)?.title || "")
    }

    return (
        <div className="card-padding">
            <div className="justify-between flex-wrap margin-bottom">
                <h3 className="normal-title margin-end">
                    <span className="itours-icon gray-chat-icon margin-end" />
                    <span className="inline-block">
                        {Dictionary.SupportTickets}
                    </span>
                </h3>

                <Link className="button blue-btn h-40" to={queryStringReserveId ? `/tickets/create?reserveId=${queryStringReserveId}` : "/tickets/create"} >
                    {Dictionary.CreateNewTicket}
                </Link>
            </div>

            <FilterTickets
                filters={filters}
                updateFilters={(filter, value) => {
                    setFilters(prevState => ({
                        ...prevState,
                        [filter]: value
                    }))
                }}
                resetFilters={() => {
                    setFilters(initialFilterState);
                    props.history.push("/profile?mode=tickets");
                }}
            />

            <div className="itours-table-holder responsive-table no-scroll-responsive-table margin-bottom">

                <table className="itours-table">
                    <thead>
                        <tr>
                            <th> {Dictionary.id} </th>
                            <th> {Dictionary.TicketType} </th>
                            <th> {Dictionary.Title} </th>
                            <th> {Dictionary.LastUpdate} </th>
                            <th>{Dictionary.status}</th>
                            <th />
                        </tr>
                    </thead>
                    {loading ? (
                        <tbody>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(item => (
                                <tr key={item}>
                                    <td colSpan={6}>
                                        <Skeleton active paragraph={{ rows: 0 }} className="one-line-skeleton margin-top-light margin-bottom-light" />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            {tickets?.map(item => {
                                const hasUnread = item.messages?.some(x => !x.isRead);
                                return (
                                    <tr key={item.id}>
                                        <td>
                                            <span className="mobile-label">
                                                {Dictionary.id}
                                            </span>
                                            <span> {item.id} </span>
                                        </td>
                                        <td>
                                            <span className="mobile-label">
                                                {Dictionary.TicketType}
                                            </span>
                                            <span className="text-end"> {typeTitle(item.titleId)} </span>
                                        </td>
                                        <td>
                                            <span className="mobile-label">
                                                {Dictionary.Title}
                                            </span>
                                            <span className="text-end"> {item.title || "--"} </span>
                                        </td>
                                        <td>
                                            <span className="mobile-label">
                                                {Dictionary.LastUpdate}
                                            </span>
                                            <span className="text-end" dir="ltr">
                                                {moment.utc(item.lastModificationTime).local().format(LAN === "IR" ? "jYYYY/jMM/jDD - HH:mm" : "YYYY/MM/DD - HH:mm")}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="mobile-label">
                                                {Dictionary.status}
                                            </span>
                                            <span className={`text-end`}>  <Tag color={getColor(item.status)} className="text-center min-w-90 font-14" >{getStatusText(item.status)}</Tag> </span>
                                        </td>

                                        <td>
                                            <Link to={`/tickets/details?id=${item.id}`} className="nowrap button small-btn black-border-btn relative min-w-80" > 
                                                {Dictionary.Details} 
                                                {!!hasUnread && <span className="ticketing-count-badge" />}
                                            </Link>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    )}
                </table>
            </div>

            <Page
                itemPerPage={10}
                length={totalCount}
                onChangeValue={(start, end) => { setPage([start, end]) }}
            />



        </div>
    )
}

export default withRouter(Ticketing);